/**
 * TanStack Query hook for fetching a single study's details.
 */

import { useQuery } from "@tanstack/react-query"
import { daeApiService } from "@/services/daeApi"
import { studyKeys } from "./useStudies"

/**
 * Fetches study details by ID.
 */
export function useStudyDetail(studyId: string | undefined) {
  return useQuery({
    queryKey: studyKeys.detail(studyId),
    queryFn: () => daeApiService.getStudyDetails(studyId!),
    enabled: !!studyId,
  })
}
